import React from "react";
import UserDetailsHeader from "../containers/UserDetailsHeader";
import "../containers/containerStyles.css";

import HomePageCardsContainer from "../containers/HomePageCardsContainer";
import { Layout } from "antd";

const HomePage = () => {
  return (
    <Layout
      style={{
        width: "100vw",
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--primary-color)",
        color: "white",
      }}
    >
      <div
        style={{
          animation: "fadeIn 2s",
        }}
      >
        <UserDetailsHeader />
      </div>
      <HomePageCardsContainer />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
          width: "100%",
          gap: "24px",
          margin: "auto 0 0 0",
        }}
      >
        <p
          style={{
            paddingLeft: "50px",
            paddingBottom: "24px",
            fontSize: "0.8em",
            color: "var(--hover-light-grey-color)",
            zIndex: "10",
          }}
        >
          © Charlie Oscar Group {new Date().getFullYear()}. 22a Leathermarket Street, SE13HP, London,
          United Kingdom
        </p>
        <img
          src="/co_logotype_off_black.svg"
          alt="Charlie Oscar"
          style={{
            width: "600px",
            minWidth: "12px",
            paddingRight: "10vw",
            position: "fixed",
            bottom: "0",
            right: "0",
          }}
        />
      </div>
    </Layout>
  );
};
export default HomePage;
